export default function htmlForPrinting(content, title) {
  return `
    <!DOCTYPE html>
    <html lang="en">
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap" rel="stylesheet"></link>
      <style>
          @page {
            size: auto;
            margin: 16mm;
          }

          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }

            body {
              font-family: 'Roboto', sans-serif;
            }
            h4, h2 {
              text-align: center;
            }
            table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0;
              border: 1px solid #666;
              border-radius: 6px;
              overflow: hidden;
            }

            thead {
              display: table-header-group;
            }

            th {
              background-color: #d3d3d3 !important;
              color: #000;
              font-weight: 600;
              text-align: left;
              padding: 6pt 8pt;
              border-bottom: 0.75pt solid #666;
              white-space: nowrap;
              border-right: 1px solid #d3d3d3;
            }

            td {
              padding: 6pt 8pt;
              font-size: 8pt;
              border-top: 0.5pt solid #aaa;
              border-right: 1px solid #d3d3d3;
            }

            th:last-child, td:last-child {
              border-right: none;
            }

            tr {
              page-break-inside: avoid;
            }

            table table th,
            table table td {
              border: none;
            }

            button {
              display: none !important;
            }
          }
        </style>
      <title>${title}</title>
    </head>
    <body>${content}</body>
    </html>
    `;
}
